
const Box = ({i})=>{
	return (
		<div className='box' id={`box-${i}`} ></div>
	);
}

export default Box;